import React, { useState, useEffect, forceUpdate, updateState, useCallback } from 'react'
import ReactMapGL, {Marker, Popup} from 'react-map-gl'
import ReactMapboxGl, { GeoJSONLayer } from 'react-mapbox-gl';
import * as MapboxGL from 'mapbox-gl';


const RouteMap = (props) => {
    console.log(props)
    const [viewport, setViewport] = useState({
        latitude: props.event.lat,
        longitude : props.event.lon,
        width: '47vw',
        height: '70vh', 
        zoom: 10

        })

        const [selectedPark, setSelectedPark] = useState(null);
    return (
      <div>
          <ReactMapGL {...viewport}
          mapboxApiAccessToken = {"pk.eyJ1IjoiZG9ueDg2IiwiYSI6ImNrNjQxZTU1YTBjbTkzZWxvNHVndm1ndGwifQ.WBe8i-op-0_aT4YncgHT3A"}
          mapStyle = "mapbox://styles/donx86/ck642rv5711b81iotjigpkv9e"
          onViewportChange = {(viewport) => 
            {setViewport(viewport);
        }}
          >
              <div>
                    <Marker latitude={props.event.lat} longitude={props.event.lon}>
                         <div>
                            <i class="fas fa-map-pin" style={{color: '#ff0000'}}></i>
                         </div>
                     </Marker>
              </div>
             
              {props.riders && props.riders.map((item) => (
                 <div>
                     <Marker latitude={item.lat} longitude={item.lon}>
                     <button className="marker-btn" onClick={e => {
                        e.preventDefault();
                        setSelectedPark(item);
                        }}>
                         <div>
                             {('color' in item) ? 
                                <i class="fas fa-map-pin" style={{color: `${item.color}`}}></i> :
                                <i class="fas fa-map-pin" style={{color: 'blue'}}></i>
                            }
                            
                         </div>
                         </button>
                     </Marker>
                 </div> 
              ))}

         {selectedPark && (
                <Popup latitude={selectedPark.lat} longitude={selectedPark.lon}
                    onClose={() => {setSelectedPark(null)}}><div>
                <h8 className='text-center' style={{color: 'black'}}>{selectedPark.firstName} {selectedPark.lastName}</h8>
                </div></Popup>
            )}
          </ReactMapGL>
      </div>
    )
  }


export default RouteMap;